const store = new Map();
function deactivate(v) {
    if (typeof v.deactivate === "function") {
        v.deactivate().catch(console.error);
    }
}
export const connectionStore = {
    set: (k, v) => {
        store.set(k, v);
        return v;
    },
    get: (k) => store.get(k),
    getAll: () => [...store.values()],
    has: (k) => store.has(k),
    delete: (k) => {
        let v = store.get(k);
        if (typeof v !== "undefined") {
            deactivate(v);
        }
        return store.delete(k);
    },
    clear: () => {
        store.forEach(deactivate);
        store.clear();
    }
};
// During browser unload we need to trigger clear of all connections
// This is going to reduce the number of open/stalled connections
/* istanbul ignore next */
window.addEventListener("unload", connectionStore.clear);
// exposing a prop on window for easier debugging in development builds
// no need to test it...
/* istanbul ignore next */
if (process.env.NODE_ENV === "development") {
    window["__SBDATALAYER__CONNECTIONSTORE"] = connectionStore;
}
//# sourceMappingURL=ConnectionStore.js.map